import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import '../Assets/Css/contact.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Form, Button, Spinner ,Card} from 'react-bootstrap';
import { IoIosSend } from 'react-icons/io';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

import contact from '../Assets/Images/herobannerimage1.avif';
import contactbg from '../Assets/Images/homebannerimage10.avif';
import { Helmet } from 'react-helmet';


export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    mobile: '',
    address: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    toast.loading("Sending your message...");

    try {
      const res = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      toast.dismiss(); 
      toast.success(res.data.message || "Enquiry sent!");
      setFormData({
        userName: '',
        email: '',
        mobile: '',
        address: '',
        message: '',
      });
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.error || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
<Helmet>
      {/* Page Title */}
      <title>Contact Us | Mobius Unity Consulting </title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Connect with Mobius Unity Consulting. Reach us via phone, email, or message form to begin your journey toward sustainable growth and innovation. "
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="Mobius Unity Consulting contact, consulting firm, sustainable growth support, email Mobius Unity, call Mobius Unity, eco consulting , community innovation"
      />

      {/* Author */}
      <meta name="author" content="Mobius Unity Consulting" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://mobiusunityconsulting.com/contact" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="Contact Mobius Unity Consulting" />
      <meta
        property="og:description"
        content="We're here to support you. Contact Mobius Unity Consulting for sustainable consulting services that empower your mission. "
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mobiusunityconsulting.com/contact" />
      <meta property="og:image" content="https://mobiusunityconsulting.com/assets/contact-og-image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Contact Mobius Unity Consulting" />
      <meta
        name="twitter:description"
        content="Connect with our team to start your journey toward regenerative business and community development. Mobius Unity Consulting"
      />
      <meta name="twitter:image" content="https://mobiusunityconsulting.com/assets/contact-twitter-image.jpg" />
      <meta name="twitter:site" content="@MobiusUnity" />
    </Helmet>


      <Toaster />

      <div className="container-fluid">
        <div className="row align-items-stretch">

          {/* Image Section (Always visible) */}
          <div className="col-md-6 p-0 position-relative">
            <img
              src={contact}
              alt="contact"
              className="contactimg"
              data-aos="zoom-in"
            />

            {/* Text overlay only for mobile */}
            <div className="text-overlay-mobile d-md-none d-flex flex-column align-items-center justify-content-center text-center">
              <h2 className="banner-heading-mobile" data-aos="zoom-in" >
                Connect with  Mobius Unity Consulting
              </h2>
              {/* <p className="banner-subtext-mobile" data-aos="zoom-in" data-aos-delay="100">
         Experience the richness of handcrafted delight. Join us on our journey to bring premium, artisan chocolate right to your doorstep.
        </p> */}
              
            </div>
          </div>

          {/* Text Section for Desktop Only */}
          <div className="col-md-6 banner-text-section 
          text-dark text-center text-md-start px-4 d-none 
          d-md-flex align-items-center justify-content-center" data-aos="zoom-in">
            <div className="row w-100">
              <div className="col-md-10 mx-auto leftdata" data-aos="zoom-in" data-aos-delay="200">
                <h2 className="banner-heading"  >
                  Connect with
                </h2>
                <p> 
                  <span className='banner-heading1'> Mobius Unity Consulting</span>
                </p>
                
              </div>
            </div>
          </div>

        </div>
      </div>


      {/* Contact Info Section with Floating Cards */}
    <Container className="py-5 mt-3 mb-3">
      <Row className="text-center mb-4" data-aos="zoom-in">
        <Col>
          <h3
            className="fw-bold text-center section-title"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            Get in <span style={{ color: '#04A1D3' }}>Touch</span>
            <span className="title-decoration mb-2"></span>
          </h3>
        </Col>
      </Row>

     <Row className="g-4 justify-content-center align-items-stretch" data-aos="zoom-in">
  <Col md={4} sm={6} xs={12}>
    <div className="h-100">
      <Card className="mobicontactcard text-center p-4 h-100">
        <div className="icon-wrapper mb-3">
          <FaEnvelope className="contact-icon" />
        </div>
        <h5>Email Address</h5>
        <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
         david@mobiusunityconsulting.com
        </h6>
      </Card>
    </div>
  </Col>
  <Col md={4} sm={6} xs={12}>
    <div className="h-100">
      <Card className="mobicontactcard text-center p-4 h-100">
        <div className="icon-wrapper mb-3" style={{ fontSize: '20px' }}>
          <FaMapMarkerAlt className="contact-icon" />
        </div>
        <h5>Location</h5>
        <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
          Texas 75077, USA
        </h6>
      </Card>
    </div>
  </Col>
</Row>

    </Container>

      <section
        className="cta-section mb-4 d-flex align-items-center"
        style={{
          backgroundImage: `url(${contactbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh"
        }}
      >
        <Container className='p-4'>
          <Row className="justify-content-center">
             <h4 className="text-center section-title"> 
             <span className='text-white'>Send Us a Message</span>
                 <span className="title-decoration mb-2"></span>
              </h4>
            <Col md={8} className="contactform p-5" data-aos="zoom-in">
            
             
              <Form className="mt-3" onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label>Your Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="userName"
                        placeholder="Enter your name"
                        value={formData.userName}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formMobile">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter your mobile number"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="animated-input"
                        maxLength={10}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAddress">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                         rows={1}
                        name="address"
                        placeholder="Enter your address"
                        value={formData.address}
                        onChange={handleChange}
                        className="animated-input"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={4}
                    placeholder="Type your message here"
                    value={formData.message}
                    onChange={handleChange}
                    className="animated-input"
                  />
                </Form.Group>

                <div className="mt-3 d-flex justify-content-center">
                  <Button className="banner1-button " type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Sending...
                      </>
                    ) : (
                      <>
                        <IoIosSend className="fs-4 me-2" style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} /> Send Message
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Google Map Iframe Section */}
      <section className="map-section mt-5">
        <Container className="p-0">
          <Row className="text-center mb-4 m-0" data-aos="zoom-in">
            <Col>
              <h3 className="fw-bold section-title">Find Us on the Map
                <span className="title-decoration"> </span>
              </h3>
              <div className="section-underline mx-auto"></div>
            </Col>
          </Row>


         

<iframe 
title=" Mobius Unity Consulting"
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.54855687639!2d-97.07007202684086!3d33.09465950920981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c32e5d0516be7%3A0x6333282b75d69262!2s810%20Green%20Valley%20Ln%2C%20Highland%20Village%2C%20TX%2075077%2C%20USA!5e0!3m2!1sen!2sin!4v1751110999982!5m2!1sen!2sin" 
width="100%" 
height="450"  
allowfullscreen="" 
loading="lazy" 
referrerpolicy="no-referrer-when-downgrade">

</iframe>

        </Container>
      </section>
    </div>
  );
}
